import { MANIFEST_ICONS } from '@vp/swan'
import type { IconProps } from '@vp/swan'

const VALID_SWAN_ICON_TYPES = new Set(Object.keys(MANIFEST_ICONS))

export const toSWANIconType = (iconType: string | undefined, fallback: IconProps['iconType']): IconProps['iconType'] =>
  iconType && VALID_SWAN_ICON_TYPES.has(iconType) ? (iconType as IconProps['iconType']) : fallback
